import request from "@/api/Request";

let publicRuleUrl = "/api/v1/public";
let RuleApi = {
    getRulesForSelectFacilityDisplay() {
        return request.get(
            publicRuleUrl + "/getBookingOrderRules",
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    downloadAttachFile() {
        return request({
            url: publicRuleUrl+ "/downloadAttachFile",
            method: "GET",
            responseType: 'blob',
        })
    },

};

export default RuleApi;
